import { createSelector } from '@reduxjs/toolkit';

import { RootState } from './index';

export const selectNewsDate = (state: RootState) => state.data.news.startPublishDate;
export const selectPageNewsUrl = (state: RootState) => state.data.content.pageUrl;
export const selectBreadcrumbsContent = (state: RootState) => state.data.content.breadcrumbs;
export const selectTabsContent = (state: RootState) => state.data.news.categories;
export const selectExtendedNews = (state: RootState) => state.data.extendedNews;

export const selectLatestNews = createSelector(
  [selectExtendedNews, selectPageNewsUrl],
  (news, baseUrl) =>
    news.map((item) => ({
      title: item.title,
      date: item.startPublishDate,
      href: `${baseUrl}details/${item.alias}`,
      labels: item.categories?.map((label) => ({ isActive: false, ...label })),
      ...item,
    })),
);
